module.exports = __webpack_public_path__ + "img/bg-login.d2471c16.jpg";